import React, {FC, useEffect} from 'react';
import {Flex, Title, Text} from '@priority-software/priority-style-react';
import FinishedImage from '../../../../../images/EOY-Finished-image.svg';
import styles from './FinishedStep.module.scss';
import texts from '../../../texts';
import {NextState} from '../../../types';
import {useFooterContext} from '../../../hooks';
import {useFiscalYear} from '../../../hooks/useFiscalYear';

export const FinishedStep: FC = () => {
    const footerState = useFooterContext();

    const [fiscalYearStateLoaded, fiscalYearState] = useFiscalYear();

    useEffect(() => {
        footerState.setFiscalYearEndDate(
            fiscalYearStateLoaded ? fiscalYearState?.prevEndDate : undefined
        );
    }, [fiscalYearStateLoaded]);

    useEffect(() => {
        if (footerState.onNextState === NextState.Processing) {
            footerState.setOnNextState(NextState.Done);
        }
    }, [footerState.onNextState]);

    return (
        <Flex
            componentClasses={styles.wrapper}
            direction={'column'}
            alignItems={'center'}
            justifyContent={'center'}
        >
            <img alt={''} src={FinishedImage} />
            <Title skin={'h2'} textColor={'primary-700'}>
                {texts['stage1_step5_title']}
            </Title>
            <Text
                skin={'paragraph-1'}
                componentClasses={styles.prompt}
                textColor={'primary-700'}
                tag={'span'}
            >
                {texts['stage1_step5_prompt']}
            </Text>
        </Flex>
    );
};
